var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleDownSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.5 12.292a.62.62 0 0 1-.441-.184L6.725 8.775a.625.625 0 1 1 .884-.884l2.892 2.892 2.892-2.892a.625.625 0 0 1 .884.884l-3.333 3.333a.63.63 0 0 1-.444.184"
})));
export default SvgAngleDownSmall;